export default __webpack_public_path__ + "static/media/message-email-icon.bfbaf53e.svg";